import { render, staticRenderFns } from "./SchemaInspectionGuideModal.vue?vue&type=template&id=1274ccc6&scoped=true"
import script from "./SchemaInspectionGuideModal.vue?vue&type=script&lang=js"
export * from "./SchemaInspectionGuideModal.vue?vue&type=script&lang=js"
import style0 from "./SchemaInspectionGuideModal.vue?vue&type=style&index=0&id=1274ccc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1274ccc6",
  null
  
)

export default component.exports